<template>
    <div class="goodStudents">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>


        <div class="centerTab">
            <div><img src="../../assets/img/index/CXGheader.png" alt="" style="width: 100%;"></div>
            <div class="menuTab">
                <div class="top">
                    <span v-for="(item, index) in menuTabList" :key="index" @click="jump(item)">{{ item.name }}</span>
                </div>
            </div>
        </div>
        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div class="contentLeft">
                        <ul>
                            <li v-for="(item, index) in menuList" :key="index" :class="active == index ? 'active' : ''">
                                <img src="../../assets/img/index/arrows4.png" alt="" v-if="active == index">
                                <div style="width: 12px;" v-else></div>
                                <span style="margin-left: 10px;">{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="contentRight">
                        <div class="top">
                            <img class="titleBackground" src="../../assets/img/index/titleBackground.png" alt="">
                            <div class="title3">
                                <img src="../../assets/img/index/creditHundred.png" alt="" style="width: 34px;">
                                <span style="margin-left: 10px;white-space: nowrap;">{{activeName}}</span>
                            </div>
                        </div>
                        <div class="bottom">
                            <ul>
                                <li v-for="(item, index) in contentList" :key="index">
                                    <span class="title" @click="toDetail(item, '优秀学员')">{{ item.name }}</span>
                                    <div class="look">
                                        <span v-if="item.publishTime">{{ item.publishTime.substring(0, 10) }}</span>
                                    </div>
                                </li>
                            </ul>
                            <el-empty class="empty" description="未找到您想要的" v-if="empty"></el-empty>
                            <el-pagination @current-change="currentChange"
                              background
                              :current-page="page"
                              layout="prev, pager, next, jumper"
                              next-text="下一页"
                              prev-text="上一页"
                              :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
export default {
    name: 'goodStudents',
    components: {
        publicHeaders,
        foot
    },
    data() {
        return {
            documentTitle: '',
            menuTabList: [
                {
                    name: '首页',
                    title: '企业诚信官',
                    url: '/integrity'
                },
                {
                    name: '培训动态',
                    title: '培训动态',
                    url: '/integrity_list'
                },
                {
                    name: '新闻图片',
                    title: '新闻图片',
                    url: '/integrity_list'
                },
                {
                    name: '通知公告',
                    title: '通知公告',
                    url: '/integrity_list'
                },
                {
                    name: '政策文件',
                    title: '政策文件',
                    url: '/integrity_list'
                },
                {
                    name: '优秀学员',
                    title: '优秀学员',
                    url: '/goodStudents'
                },
                {
                    name: '证书查询',
                    title: '证书查询',
                    url: ''
                },
                {
                    name: '师资介绍',
                    title: '师资介绍',
                    url: '/integrity_search'
                },
                {
                    name: '培训课程',
                    title: '培训课程',
                    url: '/integrity_list'
                },
                {
                    name: '推荐图书',
                    title: '推荐图书',
                    url: '/integrity_list'
                },
            ],
            menuList: [
                {
                    name: '优秀学员',
                },
            ],
            active: 0,
            activeName: '优秀学员',
            empty: false,
            page: 1,
            total: 0,
            contentList: []
        }
    },
    created() {
        this.documentTitle = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle

        this.getGoodStudents()
    },
    mounted() {
    },
    methods: {
        // 获取优秀学员列表
        getGoodStudents() {
            let _this = this
            _this.contentList = []
            let params = {
                param: '',
                page: _this.page,
                limit: 10,
            }
            api.getGoodStudents(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    _this.contentList = data.data.data
                    _this.total = data.data.total
                    if (data.data.total == 0) {
                        _this.empty = true
                    } else {
                        _this.empty = false
                    }
                } else {
                    _this.empty = true
                }
            })
            .catch(error => {
                _this.empty = true
            //   _this.$toast('网络错误，请检查网络')
            })
        },
        // 分页
        currentChange(val) {
            this.page = val;
            this.getGoodStudents()
        },

        jump(item) {
            if (item.url != '') {
                this.$router.push({
                    path: item.url,
                    query: {
                        documentTitle: item.title
                    }
                })
                // let routeUrl = this.$router.resolve({
                //   path: item.url
                // });
                // // console.log(routeUrl);
                // window.open(routeUrl.href+ '?documentTitle=' + item.title, '_blank');
            }
        },

        // 前往详情
        toDetail(item, title) {
            // let routeUrl = this.$router.resolve({
            //   path: "/integrityResult"
            // });
            let text = title + '详情'

            this.$router.push({
                name: 'integrityResult',
                query: {
                    documentTitle: text,
                    id: item.id
                }
            })
            // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + text + '&id=' + item.id, '_blank');
        },
    }
}
</script>

<style lang="less" scoped>
.goodStudents {
    position: relative;
    padding-bottom: 140px;
    .centerTab {
            width: 80%;
            margin: 0 auto;
            padding: 0 50px;
            @media only screen and (min-width: 769px) {
                min-width: 1152px;
            }
            margin-top: 10px;
            .menuTab {
                    margin-top: 15px;
                    color: #134AA6;
                    padding: 0 20px;
                    background-color: #E8F1FF;
                    .top {
                        padding: 10px 0;
                        display: flex;
                        span {
                            flex: 1;
                            cursor: pointer;
                            text-align: center;
                        }
                        span:nth-of-type(n+2) {
                            border-left: 1px solid #98C8F8;
                        }
                    }
                }
        }
    .main {
        width: 80%;
            @media only screen and (min-width: 769px) {
                min-width: 1152px;
            }
        padding: 15px 50px;
        margin: 0 auto;
        .left {
            margin-right: 5px;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 600px;
                margin-top: 10px;
                display: flex;
                justify-content: space-between;
                .contentLeft {
                    width: 26%;
                    height: 230px;
                    li {
                        display: flex;
                        justify-content: left;
                        align-items: center;
                        padding: 0 15px;
                        height: 46px;
                        line-height: 46px;
                        font-size: 20px;
                        color: #666;
                        cursor: pointer;
                        border: 1px solid #D9D9D9;
                        img {
                            display: inline-block;
                        }
                    }
                    li:nth-of-type(n+2) {
                        border-top-color: #fff;
                    }
                    .active {
                        color: #1A68E8;
                        border: 1px solid #1A68E8;
                        border-top-color: #1A68E8 !important;
                    }
                }
                .contentRight {
                    width: 73%;
                    border: 1px solid #D9D9D9;
                    padding: 10px 30px;
                    .top {
                        height: 55px;
                        position: relative;
                        .titleBackground {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                        }
                        .title3 {
                            position: absolute;
                            top: 50%;
                            transform: translateY(-50%);
                            left: 15px;
                            display: flex;
                            align-items: center;
                            font-size: 26px;
                            font-weight: 700;
                            background: linear-gradient(to bottom, #005CF3, #134BA8);
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                        }
                        .more {
                            position: absolute;
                            right: 15px;
                            top: 50%;
                            transform: translateY(-50%);
                            font-size: 18px;
                            color: #1A68E8;
                            cursor: pointer;
                        }
                    }
                    .bottom {
                        position: relative;
                        ul {
                            min-height: 630px;
                        }
                        .empty {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                        li {
                            border-bottom: 1px solid #E6E6E6;
                            display: flex;
                            justify-content: space-between;
                            padding: 25px 0 20px;
                            .title {
                                display: inline-block;
                                width: 70%;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                cursor: pointer;
                            }
                            .look {
                                width: 20%;
                                text-align: right;
                                span {
                                    /* border: 1px solid #1A68E8; */
                                    padding: 5px 10px;
                                    color: #1A68E8;
                                }
                            }
                        }
                        /deep/ .el-pagination {
                            display: flex;
                            justify-content: center;
                            margin-top: 20px;
                        }
                        /deep/ .el-pager li {
                            background: #fff;
                            border: 1px solid #ddd;
                            border-radius: 1px;
                            margin: 0;
                            height: 34px;
                            line-height: 34px;
                            width: 34px;
                        }
                        /deep/ .el-pager li:nth-of-type(n+2) {
                            border-left: none;
                        }
                        /deep/ .btn-next {
                            margin: 0;
                            height: 34px;
                            line-height: 34px;
                            padding: 0 15px;
                            display: flex;
                            align-items: center;
                            background: #fff;
                            border: 1px solid #ddd;
                            border-left: none;
                        }
                        /deep/ .btn-prev {
                            margin: 0;
                            height: 34px;
                            line-height: 34px;
                            padding: 0 15px;
                            display: flex;
                            align-items: center;
                            background: #fff;
                            border: 1px solid #ddd;
                            border-right: none;
                        }
                        /deep/ .el-pager li:not(.disabled).active {
                            background-color: #1A68E8;
                        }
                    }
                }
            }
        }
    }
}
</style>

